export default __webpack_public_path__ + "static/media/gallery_05.1799e6a8.jpg";